export default {
  'common.cancel': {
    ko: '취소',
    ja: 'キャンセル',
    en: 'Cancel',
  },
  'common.delete.q': {
    ko: '삭제 하시겠습니까?',
    ja: '削除しますか？',
    en: 'Are you sure you want to delete?',
  },
  'common.confirm': {
    ko: '확인',
    ja: 'OK',
    en: 'Yes',
  },
  'common.upload': {
    ko: '업로드',
    ja: 'アップロード',
    en: 'Upload',
  },
  'common.delete': {
    ko: '삭제',
    ja: '削除',
    en: 'Delete',
  },
  'common.reset': {
    ko: '초기화',
    ja: 'リセット',
    en: 'Reset',
  },
  'common.plus.10': {
    ko: '10 더하기',
    ja: '+10',
    en: 'Plus 10',
  },
  'common.themes.dark': {
    ko: '다크',
    ja: 'ダーク',
    en: 'dark',
  },
  'common.save.all.q': {
    ko: '모든 변경사항을 저장하시겠습니까?',
    ja: '全ての変更を保存しますか？',
    en: 'Are you sure you want to save all changes?',
  },
  'common.save.q': {
    ko: '변경사항을 저장하시겠습니까?',
    en: 'Are you sure you want to save the changes?',
    cn: 'Are you sure you want to save the changes?',
    ja: 'ての変更を保存しますか？',
  },
  'common.processed': {
    ko: '처리 되었습니다.',
    ja: '処理しました。',
    en: 'Has been processed.',
  },
  'common.close': {
    ko: '닫기',
    ja: '閉じる',
    en: 'Close',
  },
  'common.select.all': {
    ko: '전체 선택',
    ja: '全て選択',
    en: 'Select all',
  },
  'common.saved': {
    ko: '저장 되었습니다.',
    ja: '保存しました。',
    en: 'Has been saved.',
  },
  'common.add': {
    ko: '추가',
    ja: '追加',
    en: 'Add',
  },
  'common.all': {
    ko: '전체',
    ja: '全体',
    en: 'All',
  },
  'common.register': {
    ko: '등록',
    ja: '登録',
    en: 'Register',
  },
  'common.redo.all.q': {
    ko: '모든 변경사항을 취소하시겠습니까?',
    ja: '全ての変更を取り消しますか？',
    en: 'Are you sure you want to cancel all changes?',
  },
  'common.term.minute': {
    ko: '분',
    ja: '分',
    en: 'm',
  },
  'common.minus.10': {
    ko: '10 빼기',
    ja: '-10',
    en: 'Minus 10',
  },
  'common.no.srch.rslt': {
    ko: '검색된 데이터가 없습니다.',
    ja: 'データが取得されませんでした。',
    en: 'There are no search results',
  },
  // BEGIN::Added.by.KWShin.2026.07.16.
  'common.no.change': {
    ko: '변경 사항이 없습니다.',
    ja: '変更事項はありません。',
    en: 'There are no changes.',
  },
  // FINISH::Added.by.KWShin.2026.07.16.
  'common.theme': {
    ko: '테마',
    ja: 'テーマ',
    en: 'Theme',
  },
  'common.edit': {
    ko: '수정',
    ja: '修正',
    en: 'Edit',
  },
  'common.retrieve': {
    ko: '조회',
    ja: '取得',
    en: 'Retrieve',
  },
  // 무한 스크롤 목록의 '읽어온 건수 / 전체 건수' 풍선글. Added.by.KWShin.2026.09.18.
  'common.loaded.of.total': {
    ko: '읽어온 건수 / 전체 건수',
    ja: '読み込み件数 / 全件数',
    en: 'Loaded / Total',
    cn: 'Loaded / Total',
  },
  'common.under.construction': {
    ko: '준비중입니다...',
    ja: '準備中です。',
    en: 'Under construction...',
  },
  'common.fold': {
    ko: '접기',
    ja: '折り畳む',
    en: 'fold',
  },
  'common.select.done': {
    ko: '선택 완료',
    ja: '選択完了',
    en: 'Selection Complete',
  },
  'common.themes.light': {
    ko: '라이트',
    ja: 'ライト',
    en: 'light',
  },
  'common.noSelect': {
    ko: '선택하세요.',
    ja: '選択してください。',
    en: 'No Select',
  },
  'common.noFileSelect': {
    ko: '선택된 파일 없음.',
    ja: '選択されたファイルがない',
    en: 'No files selected',
  },
  'common.successful': {
    ko: '정상적으로 처리되었습니다.',
    ja: '正常に処理されました。',
    en: 'Successfully Processed.',
  },
  // BEGIN::Added.by.KWSHIN.2026.04.23.
  'common.activate.success': {
    ko: '정상적으로 활성화되었습니다.',
    en: 'Successfully activated.',
  },
  'common.deactivate.success': {
    ko: '정상적으로 비활성화되었습니다.',
    en: 'Successfully deactivated.',
  },
  // FINISH::Added.by.KWSHIN.2026.04.23.
  'common.minus.unit': {
    ko: '{unit} 빼기',
    ja: '{unit} 「-」',
    en: 'Minus {unit}',
  },
  'common.plus.unit': {
    ko: '{unit} 더하기',
    ja: '{unit} 「+」',
    en: 'Plus {unit}',
  },
  'common.language': {
    ko: '언어',
    ja: '言語',
    en: 'Language',
  },
  'common.save': {
    ko: '저장',
    ja: '保存',
    en: 'Save',
  },
  // BEGIN::Added.by.KWShin.2024.01.29.
  'common.revert': {
    ko: '되돌리기',
    ja: '元に戻す',
    en: 'Revert',
  },
  // FINISH::Added.by.KWShin.2024.01.29.
  'common.unfold': {
    ko: '펼치기',
    ja: '展開',
    en: 'unfold',
  },
  'common.term.millisecond': {
    ko: 'ms',
    en: 'ms',
  },
  'common.term.hour': {
    ko: '시간',
    ja: '時間',
    en: 'h',
  },
  'common.term.second': {
    ko: '초',
    ja: '秒',
    en: 's',
  },
  'common.localLanguageName': {
    ko: '한국어',
    ja: '日本語',
    en: 'English',
  },
  'common.download': {
    ko: '다운로드',
    ja: 'ダウンロード',
    en: 'Download',
  },
  // BEGIN::Added.by.KWShin.2026.01.12.
  'common.list': {
    ko: '목록',
    en: 'List',
    cn: 'List',
    ja: 'List',
  },
  'common.define': {
    ko: '정의',
    en: 'Definition',
    cn: 'Definition',
    ja: 'Definition',
  },
  'common.analyze': {
    ko: '분석',
    en: 'Analyze',
    cn: 'Analyze',
    ja: 'Analyze',
  },
  'common.download.q': {
    ko: '다운로드 하시겠습니까?',
    en: 'Are you sure you want to download?',
    cn: 'Are you sure you want to download?',
    ja: 'Are you sure you want to download?',
  },
  'common.info': {
    ko: '알림',
    en: 'Information',
    cn: 'Information',
    ja: 'Information',
  },
  // BEGIN::Added.by.KWShin.2026.01.12.
  // BEGIN::Added.by.KWShin.2026.01.21
  'cmmn.exec.status.0': {
    ko: '실행중',
    en: 'Running',
    ja: '',
  },
  'cmmn.exec.status.1': {
    ko: '완료됨',
    en: 'Completed',
    cn: 'Completed',
    ja: 'Completed',
  },
  'cmmn.exec.status.2': {
    ko: '오류발생',
    en: 'Error',
    cn: 'Error',
    ja: 'Error',
  },
  'cmmn.exec.status.3': {
    ko: '중단됨',
    en: 'Stopped',
    cn: 'Stopped',
    ja: 'Stopped',
  },
  // FINISH::Added.by.KWShin.2026.01.21
  // BEGIN::Added.by.KWShin.2026.01.29
  'cmmn.dialog.alert': {
    ko: '경고',
    en: 'Alert',
    cn: 'Alert',
    ja: 'Alert',
  },
  'cmmn.dialog.confirm': {
    ko: '확인',
    en: 'Confirm',
    cn: 'Confirm',
    ja: 'Confirm',
  },
  'cmmn.dialog.prompt': {
    ko: '알림',
    en: 'Prompt',
    cn: 'Prompt',
    ja: 'Prompt',
  },
  // FINISH::Added.by.KWShin.2026.01.29
  // BEGIN::Added.by.KWShin.2026.02.25.
  'cmmn.from': {
    ko: '부터',
    en: 'From',
    cn: 'From',
    ja: 'From',
  },
  'cmmn.to': {
    ko: '까지',
    en: 'To',
    cn: 'To',
    ja: 'To',
  },
  'cmmn.period': {
    ko: '기간',
    en: 'Period',
    cn: 'Period',
    ja: 'Period',
  },
  // FINISH::Added.by.KWShin.2026.02.25.
  // BEGIN::Added.by.KWShin.2026.09.03.
  'common.term.Y': {
    ko: '년',
    en: 'Year',
  },
  'common.term.M': {
    ko: '개월',
    en: 'Month',
  },
  'common.term.W': {
    ko: '주',
    en: 'Week',
  },
  'common.term.D': {
    ko: '일',
    en: 'Day',
  },
  'common.term.h': {
    ko: '시간',
    ja: '時間',
    en: 'hour',
  },
  'common.term.m': {
    ko: '분',
    ja: '分',
    en: 'minute',
  },
  'common.term.s': {
    ko: '초',
    ja: '秒',
    en: 'second',
  },
  // FINISH::Added.by.KWShin.2026.09.03.
};
